<template>
    <div class="schedules" v-if="internalValue">
        <div class="schedule" v-for="(item, index) in internalValue">
            <form-select label="Type de fermeture" multiple="false" v-model="item.type" :default="item.type" :options="scheduleTypes"></form-select>
            <form-date label="Date début" v-model="item.start_date" format="yyyy-MM-dd" time="00:00:00"></form-date>
            <form-date label="Date fin" v-model="item.end_date" format="yyyy-MM-dd" time="23:59:59"></form-date>
            <button @click="deleteSchedule(index)"><i class="icon icon-icon_delete"></i> Supprimer</button>
        </div>
        <button @click="addSchedule()">Ajouter</button>
    </div>
</template>

<script>

    export default {
        name: 'OpeningHours',
        props: ['value','select'],
        data: function () {
            return {
                internalValue: [],
                hours: [],
                scheduleTypes: []
            }
        },
        created: function() {
            this.internalValue = this.value;
            this.scheduleTypes = this.select;
        },
        methods: {
            addSchedule: function() {
                this.internalValue.push({})
            },
            deleteSchedule: function(index) {
                this.internalValue.splice(index, 1);
            }
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            },
            'internalValue'(newVal, oldVal) {
                this.$emit('input', this.internalValue);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Schedulable.vue